import React from 'react'

function oops() {
  return (
    <div className="border-2 rounded p-4">
        <div className="w-full h-8 bg-main-dark text-white flex px-2 py-1 font-bold">OOPS</div>
        <div className="p-2">
            <h1 className="text-center text-3xl">404</h1>
            <hr/>
            <div className="flex flex-row justify-evenly bg-red-500 text-white">
                <div>
                    Error
                </div>
                <div>
                    404
                </div>
            </div>
            <hr/>
            <div>
                <h2 className="text-lg">Componente no encontrado</h2>
                <div className="flex flex-row justify-evenly">
                    <div className="flex flex-col items-center">
                        <p className="text-lg">El componente que buscas no pudo ser cargado</p>
                        <p className="text-lg">Por favor intenta de nuevo</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default oops

